import { faker } from '@faker-js/faker';

import type { ChangeZakatDatePostResponse } from '../types/ChangeZakatDatePostResponse';

export function createChangeZakatDatePostResponse(
  data: NonNullable<Partial<ChangeZakatDatePostResponse>> = {}
): NonNullable<ChangeZakatDatePostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
